var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5339_4158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86517 0.134078C7.68539 -0.0446927 7.41573 -0.0446927 7.23595 0.134078L4 3.39665L0.764045 0.178771C0.584269 1.73153e-07 0.314607 1.73153e-07 0.134831 0.178771C-0.0449438 0.357542 -0.0449438 0.625698 0.134831 0.804469L3.37079 4.02235L0.134831 7.24022C-0.0449438 7.41899 -0.0449438 7.68715 0.134831 7.86592C0.224719 7.95531 0.359551 8 0.449439 8C0.539326 8 0.674157 7.95531 0.764045 7.86592L4 4.64805L7.23595 7.86592C7.32584 7.95531 7.46067 8 7.55056 8C7.64045 8 7.77528 7.95531 7.86517 7.86592C8.04494 7.68715 8.04494 7.41899 7.86517 7.24022L4.62921 4.02235L7.86517 0.804469C8.04494 0.625698 8.04494 0.312849 7.86517 0.134078Z",
    fill: "#996B68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5339_4158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.adb8eb18a9f809291664f8ba5ec74f7d.svg";
export { ForwardRef as ReactComponent };